/** An explicit zero is valid; an empty field is not a free job. */
export function priceInputPence(input: string): number | null {
  const text = input.trim().replace(',', '.');
  if (!/^(?:\d+(?:\.\d{1,2})?|\.\d{1,2})$/.test(text)) return null;
  const [whole, fraction = ''] = text.split('.');
  const pence = Number(whole || '0') * 100 + Number(fraction.padEnd(2, '0'));
  return Number.isSafeInteger(pence) ? pence : null;
}
